import type { FC } from 'react';

import { useLinkComponent } from '@eneco/link';
import { Stack, Text, TextLink } from '@eneco/sparky';
import { FooterMenuRendering } from '@sitecore/types/manual/Footer';

const SubFooterMenu: FC<{ fields: FooterMenuRendering['fields'] }> = ({ fields }) => {
  const Link = useLinkComponent();

  if (!fields.items.length) return null;

  return (
    <Stack gap="2">
      {fields.title?.value && (
        <Stack.Item>
          <Text weight="bold">{fields.title.value}</Text>
        </Stack.Item>
      )}
      <Stack.Item>
        <Stack as="ul" direction={{ initial: 'column', md: 'row' }} gap={{ initial: 6, md: 3 }} wrap="true">
          {fields.items.map(navItem => {
            const link = navItem?.fields?.link?.value;
            if (!link?.href) return null;
            return (
              <Stack.Item as="li" key={navItem.id}>
                <Link linkType={link.linktype} linkValue={link}>
                  <TextLink emphasis="low" target={link.target}>
                    {link.text || navItem.displayName}
                  </TextLink>
                </Link>
              </Stack.Item>
            );
          })}
        </Stack>
      </Stack.Item>
    </Stack>
  );
};

export { SubFooterMenu };
export default SubFooterMenu;
